import {MonthlyCostData } from '../constants/types';

export const useTotalCost=(hasConfirmed: boolean, graphData:MonthlyCostData[]) => {
    let costs: number[] = [];

    if (hasConfirmed && graphData) 
    {
      costs = graphData.map(item => item.cost);
    } 
    return costs.reduce((acc, curr) => acc + curr, 0);
  };